import { render, staticRenderFns } from "./image.vue?vue&type=template&id=1dc8d709&"
import script from "./image.vue?vue&type=script&lang=ts&"
export * from "./image.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dc8d709')) {
      api.createRecord('1dc8d709', component.options)
    } else {
      api.reload('1dc8d709', component.options)
    }
    module.hot.accept("./image.vue?vue&type=template&id=1dc8d709&", function () {
      api.rerender('1dc8d709', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/image.vue"
export default component.exports